import React, { ReactNode } from 'react'
import { InputNumber, InputNumberProps } from 'antd'

interface BetterInputNumberProps extends InputNumberProps {
  addonAfter?: ReactNode
  addonBefore?: ReactNode
}

export class BetterInputNumber extends React.Component<BetterInputNumberProps> {
  constructor(props: BetterInputNumberProps) {
    super(props)
  }

  render() {
    const { ...rest } = this.props
    if (rest.addonBefore) {
      delete rest.addonBefore
    }
    if (rest.addonAfter) {
      delete rest.addonAfter
    }
    return (
      <div style={{ display: 'flex', flexFlow: 'row' }}>
        {this.props.addonBefore && (
          <div
            className='ant-input-group-addon'
            style={{
              paddingTop: '2px',
              verticalAlign: 'middle',
              display: 'inline-table',
              lineHeight: '24px',
              height: '32px'
            }}
          >
            {this.props.addonBefore}
          </div>
        )}
        <InputNumber
          style={{
            flex: 1,
            verticalAlign: 'middle',
            borderBottomRightRadius: 0,
            borderTopRightRadius: 0
          }}
          {...rest}
        />
        {this.props.addonAfter && (
          <div
            className='ant-input-group-addon'
            style={{
              paddingTop: '2px',
              verticalAlign: 'middle',
              display: 'inline-table',
              lineHeight: '24px',
              height: '32px'
            }}
          >
            {this.props.addonAfter}
          </div>
        )}
      </div>
    )
  }
}
